import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";

import { ref, computed, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Crontab-Week',
  props: {
    cron: {
      default: true
    },
    check: {}
  },
  emits: ['update'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const weekList = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
    const radioValue = ref(2);
    const weekday = ref(1);
    const cycle01 = ref(1);
    const cycle02 = ref(2);
    const average01 = ref(1);
    const average02 = ref(1);
    const checkboxList = ref([]);
    const checkNum = ref(props.check);
    // 计算两个周期值
    const cycleTotal = computed(() => cycle01.value + '-' + cycle02.value);
    // 计算平均用到的值
    const averageTotal = computed(() => average01.value + '/' + average02.value);
    // 计算勾选的checkbox值合集
    const checkboxString = computed(() => checkboxList.value.join() === '' ? '*' : checkboxList.value.join());
    // 最近的工作日（格式）
    const weekdayCheck = computed(() => weekday.value);
    watch(radioValue, () => {
      radioChange();
    });
    watch(cycleTotal, () => {
      cycleChange();
    });
    watch(averageTotal, () => {
      averageChange();
    });
    watch(weekdayCheck, () => {
      weekdayChange();
    });
    watch(checkboxString, () => {
      checkboxChange();
    });
    // 单选按钮值变化时
    function radioChange() {
      if (radioValue.value === 1) {
        emits('update', 'week', '*');
        emits('update', 'year', '*');
      } else {
        if (props.cron.month === '*') {
          emits('update', 'month', '0', 'week');
        }
        if (props.cron.day === '*') {
          emits('update', 'day', '0', 'week');
        }
        if (props.cron.hour === '*') {
          emits('update', 'hour', '0', 'week');
        }
        if (props.cron.min === '*') {
          emits('update', 'min', '0', 'week');
        }
        if (props.cron.second === '*') {
          emits('update', 'second', '0', 'week');
        }
      }
      switch (radioValue.value) {
        case 2:
          emits('update', 'week', '?');
          break;
        case 3:
          emits('update', 'week', cycle01.value + '-' + cycle02.value);
          break;
        case 4:
          emits('update', 'week', average01.value + '#' + average02.value);
          break;
        case 5:
          emits('update', 'week', weekday.value + 'L');
          break;
        case 6:
          emits('update', 'week', checkboxString.value);
          break;
      }
    }
    // 周期两个值变化时
    function cycleChange() {
      if (radioValue.value === 3) {
        emits('update', 'week', cycleTotal.value);
      }
    }
    // 平均两个值变化时
    function averageChange() {
      if (radioValue.value === 4) {
        emits('update', 'week', averageTotal.value);
      }
    }
    // 最近工作日值变化时
    function weekdayChange() {
      if (radioValue.value === 5) {
        emits('update', 'week', weekday.value + 'L');
      }
    }
    // checkbox值变化时
    function checkboxChange() {
      if (radioValue.value === 6) {
        emits('update', 'week', checkboxString.value);
      }
    }
    __expose({
      checkNum
    });
    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_component_el_form, {
        size: "small"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            modelValue: _unref(radioValue),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(radioValue) ? radioValue.value = $event : null),
            label: 1
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode(" 周，允许的通配符[, - * / L #] ")])),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            modelValue: _unref(radioValue),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(radioValue) ? radioValue.value = $event : null),
            label: 2
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode(" 不指定 ")])),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            modelValue: _unref(radioValue),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(radioValue) ? radioValue.value = $event : null),
            label: 3
          }, {
            default: _withCtx(() => [_cache[14] || (_cache[14] = _createTextVNode(" 周期从星期 ")), _createVNode(_component_el_input_number, {
              modelValue: _unref(cycle01),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(cycle01) ? cycle01.value = $event : null),
              min: 1,
              max: 7
            }, null, 8, ["modelValue"]), _cache[15] || (_cache[15] = _createTextVNode(" - ")), _createVNode(_component_el_input_number, {
              modelValue: _unref(cycle02),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(cycle02) ? cycle02.value = $event : null),
              min: 2,
              max: 7
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            modelValue: _unref(radioValue),
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _isRef(radioValue) ? radioValue.value = $event : null),
            label: 4
          }, {
            default: _withCtx(() => [_cache[16] || (_cache[16] = _createTextVNode(" 第 ")), _createVNode(_component_el_input_number, {
              modelValue: _unref(average01),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(average01) ? average01.value = $event : null),
              min: 1,
              max: 4
            }, null, 8, ["modelValue"]), _cache[17] || (_cache[17] = _createTextVNode(" 周的星期 ")), _createVNode(_component_el_input_number, {
              modelValue: _unref(average02),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(average02) ? average02.value = $event : null),
              min: 1,
              max: 7
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            modelValue: _unref(radioValue),
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(radioValue) ? radioValue.value = $event : null),
            label: 5
          }, {
            default: _withCtx(() => [_cache[18] || (_cache[18] = _createTextVNode(" 本月最后一个星期 ")), _createVNode(_component_el_input_number, {
              modelValue: _unref(weekday),
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _isRef(weekday) ? weekday.value = $event : null),
              min: 1,
              max: 7
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            modelValue: _unref(radioValue),
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _isRef(radioValue) ? radioValue.value = $event : null),
            label: 6
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode(" 指定 ")])),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: _unref(checkboxList),
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _isRef(checkboxList) ? checkboxList.value = $event : null),
            clearable: "",
            placeholder: "可多选",
            multiple: "",
            style: {
              "width": "200px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekList, (item, index) => {
              return _createVNode(_component_el_option, {
                key: index,
                value: index + 1
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                _: 2
              }, 1032, ["value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});